import { RetryOptions } from '@reduxjs/toolkit/dist/query/retry'
import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query'
import { createApi } from '@reduxjs/toolkit/query/react'
import { setStatusData } from 'redux/store/slices/statusSlice'
import TokenService from 'services/token.service'
import { GetApplicationStatusPayload, GetApplicationStatusResponse } from 'share/types/api/main'
import { baseUrl } from 'utils/constants'

const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, RetryOptions, FetchBaseQueryMeta> =
  fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: headers => {
      const token = TokenService.getAccessToken()
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    }
  })

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQuery,
  endpoints: build => ({
    getApplicationStatus: build.query<GetApplicationStatusResponse, GetApplicationStatusPayload>({
      query: flow_uuid => ({
        url: `/core/${flow_uuid}/status/`,
        method: 'get'
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(setStatusData(data))
        } catch (err) {
          console.log(err)
        }
      }
    })
  })
})

export const { useGetApplicationStatusQuery, useLazyGetApplicationStatusQuery } = api
